module.exports = __webpack_public_path__ + "static/media/404.df2595fe.jpg";